import React from "react";
import Home from "./pages/home";
import "./App.css";

function App() {
  return (
    <div
      style={{ width: "100vw", overflow: "hidden", backgroundColor: "#314342" }}
    >
      <Home />
    </div>
  );
}

export default App;
